import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericGet, genericGetWithProcessor, genericPost, genericUpdate, paginatedGetWithProcessor, RECIBOS_EXTENSION } from "../../services/api.service";
import TableView from "../Common/TableView";
import { RecibosTableConfigs } from "./RecibosConfig";


export default function Recibos() {


    return(<>
                <TableView 
                        title={"Recibos"}

                    getEntity={paginatedGetWithProcessor(RECIBOS_EXTENSION, generalObjectBuilder(RecibosTableConfigs))}
                    postEntity={genericPost(RECIBOS_EXTENSION)}
                    editEntity={genericUpdate(RECIBOS_EXTENSION)}
                    deleteEntity={genericDelete(RECIBOS_EXTENSION)}
                    addButtonText={"Novo Recibo"} 
                    tableConfigs={RecibosTableConfigs}
                    entityName={"Recibo"}
                    dataBuildFunction={generalObjectBuilder(RecibosTableConfigs)}
                    idProp={"code"}
                    reroute={true}
                />
    </>)

}

